<script>
  import { user } from "../stores/user"
  import { onMount } from "svelte"
  import { navigate } from "svelte-routing"
  import Navbar from "../components/Navbar.svelte"

  onMount(() => {
    if (!$user) {
      navigate("/", { replace: true })
    }
  })
</script>

{#if $user}
  <Navbar />

  <div class="container-fluid py-3">
    <h3>Administrador de usuarios y permisos SBI</h3>
  </div>
{/if}
